import React, { Fragment } from 'react';

import LineItem from 'components/PaymentReq/TransactionDetail/TransactionLineItem';
import { colors, fontSize, paddingSize } from 'styles/cp';
import { SaleLine } from 'types/Sale';

type Props = {
  lineItems: Array<SaleLine>;
  currency?: string;
};

const TransactionLineItemList: React.FC<Props> = (props) => {
  const { lineItems, currency } = props;
  return (
    <Fragment>
      <ul className="item-list">
        {lineItems
          .filter((item) => item.quantity > 0)
          .map((item) => (
            <LineItem
              lineItem={item}
              currency={currency}
              key={`item-${item.id.globalId.localId}`}
            />
          ))}
      </ul>
      <style jsx>{`
        .item-list {
          padding: ${paddingSize.sm} ${paddingSize.xs};
          margin: 0px;
        }
        .item-list-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: ${paddingSize.sm} ${paddingSize.sm} 0px ${paddingSize.sm};

          & h5 {
            color: ${colors.gray03};
            font-size: ${fontSize.sm};
            margin: 0px;
          }

          & button {
            background-color: transparent;
            border: 0px solid transparent;
            color: ${colors.blue};
            cursor: pointer;
            padding: 0px;
          }
        }
      `}</style>
    </Fragment>
  );
};

export default TransactionLineItemList;
